module.exports = __webpack_public_path__ + "static/media/13_Monica_B@3x.f52d4c74.jpg";